var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.caption && _vm.caption.trim())?_c('v-card',{key:_vm.caption,staticClass:"ma-7 pa-0",class:_vm.theme.name,attrs:{"id":"caption","shaped":"","dark":"","color":_vm.theme.captionBGColor,"elevation":_vm.elevation}},[_c('h2',{staticClass:"ma-7 pa-7",style:({ color: _vm.theme.textColor })},[_vm._v(_vm._s(_vm.caption))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }